function MMOBError({errorMessage}) {
  return (
    <div style={{backgroundColor:"#ffffba", padding:"20px"}}>
      {!errorMessage ? "We had a problem with creating your account automatically, but would love to welcome you to apply to StepLadder through our application form! Click the button to start, it only takes a few minutes." : errorMessage}
    </div>
  );
}

export default MMOBError;
